export default "__VITE_ASSET__3f4c06b5__"